import qs from "qs";
import React from "react";
import { withRouter } from "react-router";

import config from "../../../../../config";
import withAddAlert from "../../../../../hocs/withAddAlert";
import withPaymentInvoices from "../../../../../hocs/withPaymentInvoices";
import withPaymentDetails from "../../../../../hocs/withPaymentDetails";
import withTransactionHistory from "../../../../../hocs/withTransactionHistory";
import withUserData from "../../../../../hocs/withUserData";
import { checkAccessTime } from "../../../../../lib/access/time";
import {
  hasUsablePaymentDetails,
  shouldShowPaymentsSettingsLoader
} from "../../../../../lib/payment/shouldShowPaymentsSettingsLoader";
import Loader from "../../../common/Loader";
import CurrentPlanBox from "../../CurrentPlanBox";
import PaymentMethodBox from "../../PaymentMethodBox";
import PremiumOfferBox from "../../PremiumOfferBox";
import TransactionHistoryBox from "../../TransactionHistoryBox";
import InvoicesBox from "../../InvoicesBox";
import InvoiceDataBox from "../../InvoiceDataBox";

@withPaymentDetails
@withTransactionHistory
@withPaymentInvoices
@withUserData
@withRouter
@withAddAlert
class PaymentsSettings extends React.Component {
  componentDidMount(): void {
    const {
      location: { search },
      addErrorAlert,
      translate,
      fetchPaymentDetails
    } = this.props;

    const queryParams = qs.parse(search.replace("?", ""));

    if (queryParams.error && queryParams.error === "501") {
      addErrorAlert({
        title: translate("Authorization error.")
      });
    }

    fetchPaymentDetails();
  }

  render() {
    const {
      paymentDetails,
      paymentDetailsError,
      currentOffer,
      currentOfferLoading,
      userData,
      transactionHistoryData,
      paymentInvoices,
      fetchPaymentInvoices,
      loading
    } = this.props;

    if (
      shouldShowPaymentsSettingsLoader({
        currentOfferLoading,
        loading,
        paymentDetails,
        paymentDetailsError
      })
    ) {
      return (
        <div className="payments-settings">
          <div className="content-section">
            <Loader />
          </div>
        </div>
      );
    }

    if (!hasUsablePaymentDetails(paymentDetails)) {
      return null;
    }

    const accessTime = checkAccessTime(paymentDetails, userData);

    return (
      <div className="payments-settings">
        {!currentOffer &&
        (accessTime.noPremiumAccess ||
          accessTime.expired ||
          paymentDetails.end_date) ? (
          <PremiumOfferBox />
        ) : null}
        <React.Fragment>
          {currentOffer || paymentDetails.end_date ? (
            <CurrentPlanBox
              paymentDetails={paymentDetails}
              currentOffer={currentOffer}
            />
          ) : null}
          {paymentDetails.resale_date ? <PaymentMethodBox /> : null}
          {config.invoicesEnabled ? (
            <React.Fragment>
              <InvoiceDataBox />
              <InvoicesBox
                userData={userData}
                paymentInvoices={paymentInvoices}
                fetchPaymentInvoices={fetchPaymentInvoices}
              />
            </React.Fragment>
          ) : null}
          <TransactionHistoryBox
            transactionHistoryData={transactionHistoryData}
          />
        </React.Fragment>
      </div>
    );
  }
}

PaymentsSettings.propTypes = {};

export default PaymentsSettings;
